/**
 * @graph-stack cortex-admin
 * @graph-domain Engineering
 * @graph-business TanStack Queryキー定義。auth/pipelinesの階層的クエリキーでキャッシュ管理
 * @graph-connects none
 */
export const queryKeys = {
  auth: {
    all: ['auth'] as const,
    current: ['auth', 'current'] as const,
  },
  pipelines: {
    all: ['pipelines'] as const,
    list: () => [...queryKeys.pipelines.all, 'list'] as const,
    detail: (id: string) => [...queryKeys.pipelines.all, 'detail', id] as const,
  },
  pipelinePermissions: {
    all: ['pipeline-permissions'] as const,
    current: () => [...queryKeys.pipelinePermissions.all, 'current'] as const,
  },
  workspacePermissions: {
    all: ['workspace-permissions'] as const,
    current: () => [...queryKeys.workspacePermissions.all, 'current'] as const,
  },
  dataViewer: {
    all: ['data-viewer'] as const,
    jobs: () => [...queryKeys.dataViewer.all, 'jobs'] as const,
    databases: () => [...queryKeys.dataViewer.all, 'databases'] as const,
  },
  workspaceUsers: {
    all: ['workspace-users'] as const,
    list: () => [...queryKeys.workspaceUsers.all, 'list'] as const,
  },
  infraGraph: {
    all: ['infra-graph'] as const,
    overview: () => [...queryKeys.infraGraph.all, 'overview'] as const,
    stack: (stack: string) => [...queryKeys.infraGraph.all, 'stack', stack] as const,
  },
  botStatus: {
    all: ['bot-status'] as const,
    latest: (host?: string) => [...queryKeys.botStatus.all, 'latest', host ?? 'default'] as const,
  },
  claudeUsage: {
    all: ['claude-usage'] as const,
    latest: (range: string) => [...queryKeys.claudeUsage.all, 'latest', range] as const,
  },
  ownershipTransfers: {
    all: ['ownership-transfers'] as const,
    list: (filter: Record<string, string | undefined>) =>
      [...queryKeys.ownershipTransfers.all, 'list', filter] as const,
    detail: (id: string) => [...queryKeys.ownershipTransfers.all, 'detail', id] as const,
  },
} as const;
